import Vue from "vue";

export default {
  setAgentInfo(state, info) {
    state.agentInfo = info;
    state.hasChecked = true;
  },

  setSessionId(state, sessionId) {
    state.sessionId = sessionId;
  },

  setOpen(state, isOpen) {
    state.isOpen = isOpen;
  },

  setStreaming(state, isStreaming) {
    state.isStreaming = isStreaming;
  },

  addMessage(state, message) {
    state.messages.push(message);
  },

  appendToLastMessage(state, chunk) {
    const last = state.messages[state.messages.length - 1];
    if (last && last.role === "assistant") {
      Vue.set(last, "content", last.content + chunk);
    }
  },

  finalizeLastMessage(state, { sources }) {
    const index = state.messages.length - 1;
    const last = state.messages[index];
    if (last && last.role === "assistant") {
      Vue.set(state.messages, index, {
        ...last,
        isStreaming: false,
        sources: sources || []
      });
    }
  },

  setLastMessageError(state, errorText) {
    const index = state.messages.length - 1;
    const last = state.messages[index];
    if (last && last.role === "assistant") {
      Vue.set(state.messages, index, {
        ...last,
        content: errorText,
        isStreaming: false,
        isError: true
      });
    }
  },

  clearMessages(state) {
    state.messages = [];
    state.sessionId = null;
  },

  resetAgent(state) {
    state.agentInfo = null;
    state.messages = [];
    state.sessionId = null;
    state.isStreaming = false;
    state.isOpen = false;
    state.hasChecked = false;
  }
};
